import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
// atoms
import { ButtonComponent } from './atoms/button/ng/button.component';
import { HeadingComponent } from './atoms/heading/ng/heading.component';
import { ImageComponent } from './atoms/image/ng/image.component';
import { InputComponent } from './atoms/input/ng/input.component';
import { InputAutocompleteComponent } from './atoms/input-autocomplete/ng/input-autocomplete.component';
import { InputCheckboxComponent } from './atoms/input-checkbox/ng/input-checkbox.component';
import { InputCheckswitchComponent } from './atoms/input-checkswitch/ng/input-checkswitch.component';
import { InputSearchComponent } from './atoms/input-search/ng/input-search.component';
import { InputSelectComponent } from './atoms/input-select/ng/input-select.component';
import { LabelComponent } from './atoms/label/ng/label.component';
import { LinkComponent } from './atoms/link/ng/link.component';
import { LoadingIndicatorComponent } from './atoms/loading-indicator/ng/loading-indicator.component';
import { MessageBoxComponent } from './atoms/message-box/ng/message-box.component';
import { RichtextComponent } from './atoms/richtext/ng/richtext.component';
import { TagComponent } from './atoms/tag/ng/tag.component';
import { TagFilterComponent } from './atoms/tag-filter/ng/tag-filter.component';
import { InputRangeSliderComponent } from './atoms/input-range-slider/ng/input-range-slider.component';
// molecules
import { BrandProductAccordionComponent } from './molecules/brand-product-accordion/ng/brand-product-accordion.component';
import { DownloadItemComponent } from './molecules/download-item/ng/download-item.component';
import { FilterMarketSwitchComponent } from './molecules/filter-market-switch/ng/filter-market-switch.component';
import { FilterMultiSelectComponent } from './molecules/filter-multiselect/ng/filter-multiselect.component';
import { FilterProductSearchComponent } from './molecules/filter-productsearch/ng/filter-productsearch.component';
import { FilterKeywordSearchComponent } from './molecules/filter-keywordsearch/ng/filter-keywordsearch.component';
import { FilterSingleSelectComponent } from './molecules/filter-singleselect/ng/filter-singleselect.component';
import { FilterTwoLevelMultiselectComponent } from './molecules/filter-two-level-multiselect/ng/filter-two-level-multiselect.component';
import { FilterWrapperComponent } from './molecules/filter-wrapper/ng/filter-wrapper.component';
import { ProductFilterComponent } from './molecules/product-filter/ng/product-filter.component';
import { ProductFilterMultipleLevelComponent } from './molecules/product-filter-multiple-level/ng/product-filter-multiple-level.component';
import { ProductFilterWrapperComponent } from './molecules/product-filter-wrapper/ng/product-filter-wrapper.component';
import { ProductFilterPropertyComponent } from './molecules/product-filter-property/ng/product-filter-property.component';
import { FilterCategorySearchComponent } from './molecules/filter-categorysearch/ng/filter-categorysearch.component';
import { FilterCategorySearchSingleLevelComponent } from './molecules/filter-categorysearch-singlelevel/ng/filter-categorysearch-singlelevel.component';
import { ProductTableComponent } from './molecules/product-table/ng/product-table.component';
import { TechnicalPropertyPopupComponent } from './molecules/technical-property-popup/ng/technical-property-popup.component';
import { ProductTableV2Component } from './molecules/product-tablev2/ng/product-tablev2.component';
import { SearchNoResultsComponent } from './molecules/search-no-results/ng/search-no-results.component';
import { SearchResultListComponent } from './molecules/search-result-list/ng/search-result-list.component';
import { SearchTabsComponent } from './molecules/search-tabs/ng/search-tabs.component';
import { ScrollableTeaserComponent } from './molecules/scrollable-teaser/ng/scrollable-teaser.component';
import { SelectedFilterTagsComponent } from './molecules/selected-filter-tags/ng/selected-filter-tags.component';
import { SelectedFilterTagsV2Component } from './molecules/selected-filter-tagsv2/ng/selected-filter-tagsv2.component';
import { TooltipComponent } from './molecules/tooltip/ng/tooltip.component';
import { TableFilterComponent } from './molecules/table-filter/ng/table-filter.component';
import { TableFilterV2Component } from './molecules/table-filterv2/ng/table-filterv2.component';
import { TeaserBannerComponent } from './molecules/teaser-banner/ng/teaser-banner.component';
import { ProductCompareButtonComponent } from './molecules/product-compare-button/ng/product-compare-button.component';
// used pipes
import { HighLightPipe } from './helpers/pipes/highlight.pipe';
import { FilterMessageComponent } from './molecules/filter-message/ng/filter-message.component';
var CovestroPatternLibraryModule = /** @class */ (function () {
    function CovestroPatternLibraryModule() {
    }
    CovestroPatternLibraryModule.decorators = [
        { type: NgModule, args: [{
                    imports: [BrowserModule, CommonModule, FormsModule],
                    declarations: [
                        ButtonComponent,
                        HeadingComponent,
                        ImageComponent,
                        InputComponent,
                        InputAutocompleteComponent,
                        InputCheckboxComponent,
                        InputCheckswitchComponent,
                        InputSearchComponent,
                        InputSelectComponent,
                        LabelComponent,
                        LinkComponent,
                        LoadingIndicatorComponent,
                        RichtextComponent,
                        TagComponent,
                        TagFilterComponent,
                        BrandProductAccordionComponent,
                        DownloadItemComponent,
                        FilterMarketSwitchComponent,
                        FilterMultiSelectComponent,
                        FilterProductSearchComponent,
                        FilterKeywordSearchComponent,
                        FilterSingleSelectComponent,
                        FilterTwoLevelMultiselectComponent,
                        FilterWrapperComponent,
                        ProductFilterComponent,
                        ProductFilterMultipleLevelComponent,
                        ProductFilterWrapperComponent,
                        ProductFilterPropertyComponent,
                        FilterCategorySearchComponent,
                        FilterCategorySearchSingleLevelComponent,
                        MessageBoxComponent,
                        ProductTableComponent,
                        ProductTableV2Component,
                        TechnicalPropertyPopupComponent,
                        SearchNoResultsComponent,
                        SearchResultListComponent,
                        SearchTabsComponent,
                        ScrollableTeaserComponent,
                        SelectedFilterTagsComponent,
                        SelectedFilterTagsV2Component,
                        TooltipComponent,
                        TableFilterComponent,
                        TableFilterV2Component,
                        InputRangeSliderComponent,
                        TeaserBannerComponent,
                        ProductCompareButtonComponent,
                        HighLightPipe,
                        FilterMessageComponent
                    ],
                    providers: [],
                    exports: [
                        ButtonComponent,
                        HeadingComponent,
                        ImageComponent,
                        InputComponent,
                        InputAutocompleteComponent,
                        InputCheckboxComponent,
                        InputCheckswitchComponent,
                        InputSearchComponent,
                        InputSelectComponent,
                        LabelComponent,
                        LinkComponent,
                        LoadingIndicatorComponent,
                        RichtextComponent,
                        TagComponent,
                        TagFilterComponent,
                        BrandProductAccordionComponent,
                        DownloadItemComponent,
                        FilterMarketSwitchComponent,
                        FilterMultiSelectComponent,
                        FilterProductSearchComponent,
                        FilterKeywordSearchComponent,
                        FilterSingleSelectComponent,
                        FilterTwoLevelMultiselectComponent,
                        FilterWrapperComponent,
                        ProductFilterComponent,
                        ProductFilterMultipleLevelComponent,
                        ProductFilterWrapperComponent,
                        ProductFilterPropertyComponent,
                        FilterCategorySearchComponent,
                        FilterCategorySearchSingleLevelComponent,
                        MessageBoxComponent,
                        ProductTableComponent,
                        ProductTableV2Component,
                        TechnicalPropertyPopupComponent,
                        SearchNoResultsComponent,
                        SearchResultListComponent,
                        SearchTabsComponent,
                        ScrollableTeaserComponent,
                        SelectedFilterTagsComponent,
                        SelectedFilterTagsV2Component,
                        TooltipComponent,
                        TableFilterComponent,
                        TableFilterV2Component,
                        InputRangeSliderComponent,
                        TeaserBannerComponent,
                        ProductCompareButtonComponent,
                        FilterMessageComponent
                    ],
                },] }
    ];
    return CovestroPatternLibraryModule;
}());
export { CovestroPatternLibraryModule };
//# sourceMappingURL=covestro-pattern-library.module.js.map